



















































































import {
  defineComponent,
  onMounted,
  onUnmounted,
  PropType,
  Ref,
  ref,
} from '@vue/composition-api'
import AButton from '@/components/AButton'
import AIcon from '@/components/AIcon'
import AStarRating from '@/components/AStarRating'
import { mdiThumbUpOutline } from '@mdi/js'
import { ReviewComment, ReviewImage } from '@/interfaces/Product'
import AProductReviewComment from './AProductReviewComment.vue'
import * as productApi from '@/api/product'
import lightGallery from 'lightgallery'
import lgZoom from 'lightgallery/plugins/zoom'
import 'lightgallery/scss/lightgallery.scss'
import 'lightgallery/scss/lg-zoom.scss'
import { LightGallery } from 'lightgallery/lightgallery'

const votedEvent = 'voted'

export default defineComponent({
  name: 'AProductReview',

  components: { AButton, AIcon, AStarRating, AProductReviewComment },

  model: {
    prop: 'review',
  },

  props: {
    id: {
      type: Number,
      required: true,
    },
    verified: {
      type: Boolean,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    author: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    loggedIn: {
      type: Boolean,
      required: true,
    },
    loginUrl: {
      type: String,
      required: true,
    },
    upvotes: {
      type: Number,
      required: true,
    },
    hasVoted: {
      type: Boolean,
      default: false,
    },
    comments: {
      type: Array as PropType<ReviewComment[]>,
      default: [] as ReviewComment[],
    },
    images: {
      type: Array as PropType<ReviewImage[]>,
      default: [] as ReviewImage[],
    },
  },

  emits: [votedEvent],

  setup(props, ctx) {
    const gallery: Ref<LightGallery | undefined> = ref()
    const galleryElement: Ref<HTMLElement | undefined> = ref()

    onMounted(() => {
      if (galleryElement.value) {
        gallery.value = lightGallery(galleryElement.value, {
          plugins: [lgZoom],
        })
      }
    })

    onUnmounted(() => {
      if (gallery.value) {
        gallery.value.destroy()
      }
    })

    const voteLoading = ref(false)
    async function vote() {
      voteLoading.value = true

      /*if (!props.loggedIn) {
        document.location.href = props.loginUrl
        return
      }*/

      const { data: upvotes } = await productApi.voteReview(props.id, props.hasVoted)
      ctx.emit(votedEvent, upvotes)
      voteLoading.value = false
    }

    return { galleryElement, mdiThumbUpOutline, voteLoading, vote }
  },
})
